export class EntityDto {
    id: number;
}
